import moment from 'moment';
import apiClientServices from '../../../../api-client';
import { SessionStorageExistence } from './storage';
export const handleSessionFrontendLogs = () => {
    let frontendLogs = [];
    let logStorage = SessionStorageExistence("logs");
    if (logStorage.isExist) {
        frontendLogs = logStorage.data;
    }
    return frontendLogs;
};
export const networkLoggingService = () => {
    const requestInterceptor = apiClientServices.interceptors.request.use((config) => {
        // Attach start time to the request configuration
        config.metadata = { startTime: new Date() };
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    const responseInterceptor = apiClientServices.interceptors.response.use((response) => {
        var _a, _b;
        // Calculate response time
        const metadata = response.config.metadata;
        const endTime = new Date();
        const responseTime = endTime.getTime() - metadata.startTime.getTime();
        const request = {
            requestURL: response.config.url,
            method: (_a = response.config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            payload: response.config.data,
            requestTimestamp: moment((_b = response.config.metadata) === null || _b === void 0 ? void 0 : _b.startTime).format("DD MMM YYYY, h:mm:ss a")
        };
        const res = {
            status: response.status,
            data: response.data,
            responseTime: responseTime,
            responseTimestamp: moment().format("DD MMM YYYY, h:mm:ss a")
        };
        const frontendLogs = handleSessionFrontendLogs();
        frontendLogs.push({
            apiRequest: request,
            apiResponse: res,
        });
        sessionStorage.setItem("logs", JSON.stringify(frontendLogs));
        return response;
    }, (error) => {
        var _a, _b, _c;
        const metadata = error.config.metadata;
        const request = {
            requestURL: error.config.url,
            method: (_a = error.config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            payload: error.config.data,
            requestTimestamp: moment(metadata === null || metadata === void 0 ? void 0 : metadata.startTime).format("DD MMM YYYY, h:mm:ss a")
        };
        const frontendLogs = handleSessionFrontendLogs();
        frontendLogs.push({
            apiRequest: request,
            apiErrorResponse: {
                message: error.message,
                status: (_b = error.response) === null || _b === void 0 ? void 0 : _b.status,
                data: (_c = error.response) === null || _c === void 0 ? void 0 : _c.data,
            },
            date: moment().format("DD MMM YYYY, h:mm:ss a")
        });
        sessionStorage.setItem("logs", JSON.stringify(frontendLogs));
        return Promise.reject(error);
    });
    const cleanup = () => {
        // Clean up interceptors
        apiClientServices.interceptors.request.eject(requestInterceptor);
        apiClientServices.interceptors.response.eject(responseInterceptor);
    };
    return { cleanup };
};
